"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var version_1 = __importDefault(require("../version"));
var constants = __importStar(require("./constants"));
var generateImageAssetFileName_1 = __importDefault(require("./generateImageAssetFileName"));
var getImageAssetUrl = function (args) {
    var setName = args.setName, assetName = args.assetName, dark = args.dark, density = args.density, format = args.format;
    var fileName = (0, generateImageAssetFileName_1.default)({
        assetName: assetName,
        setName: setName,
        dark: dark,
        density: density,
        format: format,
    });
    return "".concat(constants.baseCdnUrl, "/").concat(version_1.default, "/").concat(setName, "/").concat(fileName);
};
exports.default = getImageAssetUrl;
